import React from 'react'
import CalenderBookingFront from '../../Components/Frontend/CalenderBookingFront'

function CheckAvailability() {
    return (
        <div className="container mx-auto">
            <CalenderBookingFront />
        </div>

    )
}

export default CheckAvailability